export default __webpack_public_path__ + "static/media/ContentB4096.766fb0a5.png";